/**
 * Layout constants shared by the launcher and the lazily loaded panel.
 * Kept in its own module so the launcher does not pull the panel chunk in.
 */

/** Width of the desktop panel; the launcher slides left by this much while open. */
export const HELP_PANEL_WIDTH = 400;

/**
 * Above the sticky app header (1000) and the sidebar (1000/1001): lower values
 * let the header cover the panel's title bar, so its close button could not be
 * reached.
 */
export const HELP_PANEL_Z_INDEX = 1050;

/** Above the open panel so the round button stays clickable to close the chat. */
export const HELP_LAUNCHER_Z_INDEX = 1060;
